'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import NavbarController from './navbar.controller.js';
import NavbarSvc from './navbar.service.js';
import navbarTemplate from './navbar.pug';

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: navbarTemplate,
    controller: NavbarController,
    controllerAs: 'navvm'
  })
  .factory('NavbarSvc', NavbarSvc)
  .name;
